import { render, staticRenderFns } from "./UiMarketCarts.vue?vue&type=template&id=1e122670&"
import script from "./UiMarketCarts.vue?vue&type=script&lang=js&"
export * from "./UiMarketCarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports